import React from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon';
import Paragraph from './Paragraph';
import './Spinner.scss';

const Spinner = (props) => {
  const {
    dark,
    primary,
    secondary,
    tertiary,
    medium,
    text,
  } = props;

  return (
    <span className="spinner-wrapper">
      <span className="spinner">
        <Icon
          name="loader"
          medium={medium}
          dark={dark}
          primary={primary}
          secondary={secondary}
          tertiary={tertiary}
        />
      </span>
      {text && (
        <div className="text">
          <Paragraph>
            {text}
          </Paragraph>
        </div>
      )}
    </span>
  );
};

Spinner.defaultProps = {
  dark: false,
  primary: false,
  secondary: false,
  tertiary: false,
  medium: false,
  text: null,
};

Spinner.propTypes = {

  /** Theme dark */
  dark: PropTypes.bool,

  /** Style primary */
  primary: PropTypes.bool,

  /** Style secondary */
  secondary: PropTypes.bool,

  /** Style tertiary */
  tertiary: PropTypes.bool,

  /** Size medium */
  medium: PropTypes.bool,

  /** Loading text */
  text: PropTypes.string,
};

export default Spinner;
